import { Octokit } from "@octokit/rest";
import {
  GetResponseTypeFromEndpointMethod,
  GetResponseDataTypeFromEndpointMethod,
} from "@octokit/types";
import linkifyString from "linkify-string";
import { A, D, O, S, pipe } from '@mobily/ts-belt'

import { branchstore, commits, workflowgroups } from "./store";
import { BranchData, Status, WorkflowGroups, WorkflowResult } from "./types";
import { signal } from "@preact/signals";

const token = import.meta.env.VITE_GITHUB_TOKEN;
console.log(token);

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const fetch2: typeof fetch = async (url, options) => {
  options = options ?? {};
  options = {...options, cache: 'force-cache'};
  const resp = await fetch(url, options);
  return resp;
};

const octokit = new Octokit({
  auth: token,
  request: {
    fetch: fetch2,
  }
});

console.log(await octokit.request('GET /'));

const owner = 'katrinafyi';
const repo = 'pac-nix';
const branch = 'main';

// const commitsresp = await octokit.repos.listCommits({ owner, repo, });
//
// commits.value = commitsresp.data.map(p => {
//   const commit = p.commit;
//   const author = `${commit.author.name} <${commit.author.email}>`;
//   return {
//     hash: p.sha,
//     message: commit.message,
//     author: author,
//     date: new Date(commit.author.date),
//     owner,
//     repo,
//   };
// });

const runsresp = octokit.actions.listWorkflowRunsForRepo({
  owner, repo, branch, per_page: 30
});

function statusOfResponse(x: string): Status {
  const mapping = {
    'success': 'pass',
    'failure': 'fail',
  } as const;
  return mapping[x] ?? x;
}

function expandParents(x: string): string[] {
  let [hd, tl] = x.split(' / ');
  if (tl) {
    return [hd, ...expandParents(tl)];
  }

  [hd, tl] = x.split(' (');
  if (tl && tl.endsWith(')')) {
    tl = tl.substring(0, tl.length-1).replace(/, /g, ' / ');
    return [hd, ...expandParents(tl)];
  }
  return [x];
}

async function workflowGroupsOfJobs(parent, run_id: number): Promise<WorkflowResult[]> {
  const resp = await octokit.actions.listJobsForWorkflowRun({
    owner, repo, run_id, per_page: 100
  });

  return resp.data.jobs.map(x => ({
    parents: [parent, x.name].flatMap(expandParents),
    fullname: parent + ' / ' + x.name,
    commit: x.head_sha,
    status: statusOfResponse(x.conclusion),
    url: x.html_url,
  }));
}

async function processWorkflowRun(title, run): Promise<WorkflowResult[]> {
  return workflowGroupsOfJobs(title, run.id);
}

async function resolveObject<T extends Record<keyof T, any>>(obj: T): Promise<{ [K in keyof T]: Awaited<T[K]> }> {
  return Promise.all(
    Object.entries(obj).map(async ([k, v]) => [k, await v])
  ).then(Object.fromEntries);
}

type WorkflowRuns = GetResponseDataTypeFromEndpointMethod<typeof octokit.actions.listWorkflowRunsForRepo>['workflow_runs'];
type HeadCommit = WorkflowRuns[number]['head_commit'];

async function addCommitIfNotExists(store: BranchData, commit: HeadCommit): Promise<void> {
  if (A.find(store.commits.value, x => x.hash === commit.id))
    return;

  store.commits.value = [{
    hash: commit.id,
    message: commit.message,
    author: `${commit.author.name} <${commit.author.email}>`,
    date: new Date(commit.timestamp),
    owner,
    repo,
  }, ...store.commits.value];
};

async function workflowGroupsOfRuns(store: BranchData, data: WorkflowRuns): Promise<WorkflowGroups[]> {

  for (let index = data.length - 1; index >= 0; index--) {
    await addCommitIfNotExists(store, data[index].head_commit);
  }

  const grouped = A.groupBy(data, x => x.name);
  const results = [];
  for await (const [title, runs] of D.toPairs(grouped)) {
    for (const run of runs) {
      const res = await processWorkflowRun(title, run);
      await sleep(50);

      for (const job of res) {
        const key = job.fullname;
        if (!(key in store.results.value))
          store.results.value = {...store.results.value, [key]: signal([])};

        const resultssig = store.results.value[key];
        resultssig.value = [...resultssig.value, job];
      }
    }
  }
  return [];
}

runsresp.then(x => workflowGroupsOfRuns(branchstore, x.data.workflow_runs));

export function getUrlForCommit({hash, owner, repo}) {
  return `https://github.com/${owner}/${repo}/commit/${hash}`;
}

const commitRegex = /([0-9a-fA-F]{6})[0-9a-fA-F]{34}/g;
const httpRegex = /^https?:\/\//;

export function linkifyText(s: string) {
  const format = {
    url: (x: string) => x.replace(commitRegex, '$1').replace(httpRegex, ''),
  };
  return linkifyString(s, {format, target: '_blank'});
}
